import { render, staticRenderFns } from "./TreatmentReservationCompletePage.vue?vue&type=template&id=2169b11e&scoped=true&"
import script from "./TreatmentReservationCompletePage.vue?vue&type=script&lang=ts&"
export * from "./TreatmentReservationCompletePage.vue?vue&type=script&lang=ts&"
import style0 from "./TreatmentReservationCompletePage.vue?vue&type=style&index=0&id=2169b11e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2169b11e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
